import * as yup from "yup";

const passwordRules = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\W]{8,}$/;
const passwordMessage =
  "Password must be at least 8 characters, contain 1 uppercase, 1 lowercase, and 1 number";

export const createAdminSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  // Roles are created dynamically (Roles page) and the form's dropdown is
  // populated from the roles API, so accept any role name — don't restrict to a
  // hardcoded enum. The dropdown constrains the choice; the backend validates it.
  role: yup.string().required("Role is required"),
  password: yup
    .string()
    .required("Password is required")
    .matches(passwordRules, passwordMessage),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),
  isActive: yup.boolean().default(true),
  notifyOnRegistration: yup.boolean().default(false),
});

export const updateAdminSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  // Roles are created dynamically (Roles page) and the form's dropdown is
  // populated from the roles API, so accept any role name — don't restrict to a
  // hardcoded enum. The dropdown constrains the choice; the backend validates it.
  role: yup.string().required("Role is required"),
  password: yup
    .string()
    .test(
      "password-strength",
      passwordMessage,
      (value) => !value || passwordRules.test(value),
    )
    .nullable()
    .transform((v) => (v === "" ? null : v)),
  confirmPassword: yup
    .string()
    .test("passwords-match", "Passwords must match", function (value) {
      return !this.parent.password || value === this.parent.password;
    })
    .nullable()
    .transform((v) => (v === "" ? null : v)),
  isActive: yup.boolean().default(true),
  notifyOnRegistration: yup.boolean().default(false),
});
